/* Milan Salvatore — theme behaviour */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var n = Math.round(cents) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  window.MSmoney = money;

  /* Pair savings: 2nd pair 20%, 3rd and later 30%, applied to the lower-priced pairs */
  function pairDiscount(prices) {
    var s = prices.slice().sort(function (a, b) { return b - a; });
    var d2 = 0, d3 = 0;
    s.forEach(function (p, i) { if (i === 1) d2 += p * 0.2; if (i >= 2) d3 += p * 0.3; });
    return { d2: Math.round(d2), d3: Math.round(d3) };
  }
  window.MSpairDiscount = pairDiscount;

  function tierRender(root, count) {
    if (!root) return;
    var reached = Math.min(count, 3);
    var msg = count <= 0 ? 'Choose your first pair to begin.'
      : count === 1 ? 'Add a second pair — it is 20% off.'
      : count === 2 ? 'Add a third pair — it is 30% off.'
      : 'Il Trio complete — your best price is applied.';
    var next = count <= 1 ? 'Next: a second pair unlocks 20% off that pair'
      : count === 2 ? 'Next: a third pair unlocks 30% off that pair'
      : 'Every pair after the third is also 30% off';
    var m = $('[data-tier-msg]', root); if (m) m.textContent = msg;
    var n = $('[data-tier-next]', root); if (n) n.textContent = next;
    var f = $('[data-tier-fill]', root); if (f) f.style.width = (reached <= 1 ? 0 : reached === 2 ? 50 : 100) + '%';
    $$('.tier-node', root).forEach(function (el, i) { el.classList.toggle('on', reached >= i + 1); });
  }
  window.MStier = tierRender;
  $$('[data-tier]').forEach(function (el) { tierRender(el, parseInt(el.getAttribute('data-tier'), 10) || 0); });

  /* Galleries */
  $$('[data-gal]').forEach(function (root) {
    var trk = $('.trk', root); if (!trk) return;
    var slides = Array.prototype.slice.call(trk.children);
    var n = slides.length, cur = 0;
    var dots = $('.dots', root), view = $('[data-view]', root), thumbs = $$('[data-thumb]', root);
    if (dots) { dots.innerHTML = slides.map(function (_, i) { return '<span' + (i ? '' : ' class="on"') + '></span>'; }).join(''); }
    function label(i) { var im = $('img', slides[i]); return (im && im.getAttribute('data-label')) || ''; }
    function paint() {
      if (dots) $$('span', dots).forEach(function (d, i) { d.classList.toggle('on', i === cur); });
      if (view) view.textContent = label(cur) + ' · ' + (cur + 1) + '/' + n;
      thumbs.forEach(function (t, i) { t.classList.toggle('on', i === cur); });
    }
    function go(i) { cur = (i + n) % n; trk.scrollTo({ left: cur * trk.clientWidth, behavior: 'smooth' }); paint(); }
    root._galCur = function () { return slides[cur]; };
    trk.addEventListener('scroll', function () {
      var i = Math.round(trk.scrollLeft / Math.max(trk.clientWidth, 1));
      if (i !== cur && i >= 0 && i < n) { cur = i; paint(); }
    }, { passive: true });
    var pv = $('[data-prev]', root), nx = $('[data-next]', root);
    if (pv) pv.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur - 1); });
    if (nx) nx.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur + 1); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    paint();
  });

  /* Hover magnifier */
  $$('.zoom').forEach(function (box) {
    var lens = document.createElement('span');
    lens.className = 'ms-lens'; lens.setAttribute('aria-hidden', 'true');
    box.appendChild(lens);
    var Z = 2.6, R = 85;
    box.addEventListener('mousemove', function (e) {
      var galRoot = $('.trk', box) ? box.closest('[data-gal]') : null;
      var slide = galRoot && galRoot._galCur ? galRoot._galCur() : box;
      var img = slide ? $('img', slide) : null;
      if (!img || img.hasAttribute('data-nozoom')) { lens.style.display = 'none'; return; }
      var b = box.getBoundingClientRect(), r = img.getBoundingClientRect();
      var x = e.clientX - b.left, y = e.clientY - b.top;
      lens.style.display = 'block';
      lens.style.left = (x - R) + 'px'; lens.style.top = (y - R) + 'px';
      lens.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      lens.style.backgroundSize = (r.width * Z) + 'px ' + (r.height * Z) + 'px';
      lens.style.backgroundPosition = (R - (e.clientX - r.left) * Z) + 'px ' + (R - (e.clientY - r.top) * Z) + 'px';
    });
    box.addEventListener('mouseleave', function () { lens.style.display = 'none'; });
  });

  /* Home filter */
  $$('[data-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var g = btn.getAttribute('data-filter');
      $$('[data-filter]').forEach(function (b) { b.classList.toggle('on', b === btn); });
      $$('[data-g]').forEach(function (c) { c.classList.toggle('ms-hidden', g !== 'all' && c.getAttribute('data-g') !== g); });
    });
  });

  /* Cart count */
  function setCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }
  window.MSrefreshCart = function () {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  };

  /* Product form */
  $$('[data-product-form]').forEach(function (form) {
    var idIn = $('input[name="id"]', form), cta = $('[data-cta]', form), szLabel = $('[data-size-label]', form);
    var added = $('[data-added]', form), err = $('[data-error]', form), price = form.getAttribute('data-price');
    $$('.sz', form).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        $$('.sz', form).forEach(function (x) { x.classList.toggle('on', x === b); });
        idIn.value = b.getAttribute('data-id');
        if (szLabel) szLabel.textContent = b.textContent;
        var ol = $('[data-offer-link]'); if (ol) { var u = ol.getAttribute('href').split('&v=')[0]; ol.setAttribute('href', u + '&v=' + b.getAttribute('data-id')); }
        cta.disabled = false; cta.textContent = 'Add to bag · ' + (b.getAttribute('data-price') || price);
        if (added) added.classList.add('ms-hidden');
      });
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idIn.value) return;
      cta.disabled = true; cta.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idIn.value, 10), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          cta.textContent = 'Added to bag'; cta.disabled = false; if (added) added.classList.remove('ms-hidden'); if (err) err.classList.add('ms-hidden');
          var sb = $('.sz.on', form); if (sb) { var l = parseInt(sb.getAttribute('data-left'), 10) - 1; sb.setAttribute('data-left', l); if (l <= 0) { sb.disabled = true; sb.setAttribute('data-inbag', ''); sb.classList.remove('on'); idIn.value = ''; cta.textContent = 'Added to bag'; cta.disabled = true; } }
          return window.MSrefreshCart();
        })
        .catch(function (j) { cta.disabled = false; cta.textContent = 'Add to bag'; if (err) { err.textContent = window.MSaddError ? window.MSaddError(j) : 'Sorry — that size could not be added.'; err.classList.remove('ms-hidden'); } });
    });
  });

  /* Interest toggles → customer tags */
  $$('[data-interests]').forEach(function (wrap) {
    var form = wrap.closest('form'), tags = $('input[name="contact[tags]"]', form);
    function sync() {
      var t = ['private-list'];
      $$('[data-interest]', wrap).forEach(function (b) { if (b.getAttribute('aria-pressed') === 'true') t.push('interest-' + b.getAttribute('data-interest')); });
      tags.value = t.join(', ');
    }
    $$('[data-interest]', wrap).forEach(function (b) {
      b.addEventListener('click', function () {
        var on = b.getAttribute('aria-pressed') !== 'true';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.style.background = on ? '#2A241F' : 'transparent'; b.style.color = on ? '#F3EFE8' : '#2A241F';
        sync();
      });
    });
    sync();
  });
  $$('form[data-validate-email]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var em = $('input[type="email"]', form), msg = $('[data-email-error]', form);
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value || '')) { e.preventDefault(); if (msg) msg.classList.remove('ms-hidden'); em.focus(); }
    });
  });

  /* Concierge: service cards choose the topic */
  $$('[data-service]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sel = $('#c-topic'); if (sel) sel.value = b.getAttribute('data-service');
      $$('[data-service]').forEach(function (x) {
        var on = x === b; x.style.background = on ? '#FFFFFF' : '#EAE3D8'; x.style.border = on ? '1px solid #2A241F' : '1px dashed #9C8169';
      });
      var f = $('#concierge-form'); if (f) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* Sizing calculator */
  var sz = $('[data-sizer]');
  if (sz) {
    var MEN = [[7,40,6,26.27,10.34],[8,41,7,26.93,10.60],[9,42,8,27.60,10.86],[10,43,9,28.26,11.13],[10.5,44,9.5,28.92,11.40],[11,45,10,29.59,11.66],[12,46,11,30.25,11.94],[13,47,12,30.91,12.17],[14,48,13,32.10,12.64],[15,49,14,32.65,12.86]];
    var WOMEN = [[4,35,2,22.54,8.87],[5,36,3,23.20,9.13],[6,37,4,23.97,9.44],[7,38,5,24.63,9.70],[8,39,6,25.30,9.96],[9,40,7,25.96,10.22],[10,41,8,26.63,10.48]];
    var st = { g: 'men', unit: 'cm' };
    var inp = $('#foot'), res = $('[data-result]'), note = $('[data-result-note]'), title = $('[data-chart-title]'), body = $('[data-chart]');
    function draw() {
      var data = st.g === 'men' ? MEN : WOMEN, v = parseFloat(inp.value);
      var cm = isNaN(v) ? null : (st.unit === 'cm' ? v : v * 2.54), hit = null;
      if (cm) hit = data.filter(function (r) { return r[3] >= cm - 0.15; })[0] || null;
      inp.placeholder = st.unit === 'cm' ? 'e.g. 27.5' : 'e.g. 10.8';
      if (!cm) { res.textContent = '—'; note.textContent = 'Enter a length to see your size.'; }
      else if (hit) { res.textContent = 'US ' + hit[0]; note.textContent = 'EU ' + hit[1] + ' · UK ' + hit[2] + ' · ' + (st.g === 'men' ? 'Men' : 'Women'); }
      else { res.textContent = 'Beyond our range'; note.textContent = 'Write to the Concierge and we will advise.'; }
      title.textContent = st.g === 'men' ? "Men's size chart" : "Women's size chart";
      body.innerHTML = data.map(function (r) {
        var on = hit && hit[0] === r[0];
        return '<div role="row" style="display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); border-bottom: 1px dashed #C9B79F;' + (on ? ' background: #EAE3D8; font-weight: 600' : '') + '">' +
          [r[0], r[1], r[2], r[3].toFixed(2), r[4].toFixed(2)].map(function (c) { return '<span role="cell" style="padding: 14px 12px; font-size: 14px">' + c + '</span>'; }).join('') + '</div>';
      }).join('');
      $$('[data-sz-g]').forEach(function (b) { var on = b.getAttribute('data-sz-g') === st.g; b.style.background = on ? '#EDE5D8' : 'transparent'; b.style.color = on ? '#2A241F' : '#EDE5D8'; });
      $$('[data-sz-u]').forEach(function (b) { var on = b.getAttribute('data-sz-u') === st.unit; b.style.background = on ? '#EDE5D8' : 'transparent'; b.style.color = on ? '#2A241F' : '#EDE5D8'; });
    }
    $$('[data-sz-g]').forEach(function (b) { b.addEventListener('click', function () { st.g = b.getAttribute('data-sz-g'); draw(); }); });
    $$('[data-sz-u]').forEach(function (b) { b.addEventListener('click', function () { st.unit = b.getAttribute('data-sz-u'); draw(); }); });
    inp.addEventListener('input', draw);
    draw();
  }

  /* Cart: gift note */
  var gift = $('#gift');
  if (gift) {
    var gw = $('[data-gift-wrap]');
    var syncGift = function () { gw.classList.toggle('ms-hidden', !gift.checked); };
    gift.addEventListener('change', syncGift); syncGift();
  }
  /* Bag suggestions: choose a size, then add */
  $$('[data-suggest]').forEach(function (card) {
    var sel = $('[data-suggest-size]', card), btn = $('[data-suggest-add]', card);
    sel.addEventListener('change', function () { btn.disabled = !sel.value; btn.textContent = sel.value ? 'Add to bag · ' + sel.options[sel.selectedIndex].text : 'Add to bag'; });
    btn.addEventListener('click', function () {
      if (!sel.value) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(sel.value, 10), quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; window.location.reload(); }); })
        .catch(function (j) { btn.disabled = false; btn.textContent = 'Size unavailable'; var m = card.querySelector('[data-suggest-err]'); if (!m) { m = document.createElement('p'); m.setAttribute('data-suggest-err', ''); m.style.cssText = 'margin:0;font-size:12px;color:#8C3B2E'; card.appendChild(m); } m.textContent = window.MSaddError ? window.MSaddError(j) : 'That size could not be added.'; });
    });
  });
})();
